import WhatsappTemplatesAPI from '../../api/whatsappTemplates';

// A lista de templates NÃO vive aqui: ela chega no payload da inbox
// (`message_templates`), que é o mesmo cache que o picker de envio lê. Este
// módulo cuida só das ações de escrita e do estado da tela.
const SYNC_SETTLE_MS = 4000;

export const state = {
  uiFlags: { isCreating: false, isSyncing: false },
  error: null,
};

export const getters = {
  getUIFlags: $state => $state.uiFlags,
  getError: $state => $state.error,
};

export const mutations = {
  SET_WA_TEMPLATE_UI_FLAG($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
  SET_WA_TEMPLATE_ERROR($state, error) {
    $state.error = error;
  },
};

export const actions = {
  async create({ commit, dispatch }, { inboxId, formData }) {
    commit('SET_WA_TEMPLATE_UI_FLAG', { isCreating: true });
    commit('SET_WA_TEMPLATE_ERROR', null);
    try {
      const { data } = await WhatsappTemplatesAPI.create(inboxId, formData);
      // O backend enfileira o sync; recarrega as inboxes depois de um respiro
      // pra lista já mostrar o template novo como PENDING.
      setTimeout(
        () => dispatch('inboxes/get', null, { root: true }),
        SYNC_SETTLE_MS
      );
      return data;
    } catch (error) {
      const message =
        error?.response?.data?.error || 'Não foi possível criar o template';
      commit('SET_WA_TEMPLATE_ERROR', message);
      throw error;
    } finally {
      commit('SET_WA_TEMPLATE_UI_FLAG', { isCreating: false });
    }
  },
  async sync({ commit, dispatch }, inboxId) {
    commit('SET_WA_TEMPLATE_UI_FLAG', { isSyncing: true });
    try {
      await WhatsappTemplatesAPI.sync(inboxId);
      setTimeout(
        () => dispatch('inboxes/get', null, { root: true }),
        SYNC_SETTLE_MS
      );
    } finally {
      commit('SET_WA_TEMPLATE_UI_FLAG', { isSyncing: false });
    }
  },
};

export default { namespaced: true, state, getters, actions, mutations };
